import { BREAKPOINTS } from '@skyscanner/backpack-web/bpk-component-breakpoint';
import { BpkButtonV2 } from '@skyscanner/backpack-web/bpk-component-button';
import ArrowRightIcon from '@skyscanner/backpack-web/bpk-component-icon/sm/long-arrow-right';
import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { scrollToHotelPrices } from '../../Navigation';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './PriceCta.module.scss';

import {
  useLowestPrice,
  usePollingStatus,
} from '@hotels-hotel-detail/data-access/hooks/useHotelOffersContext';
import withBpkBreakpoint from '@shared/ui/common/BpkBreakpoint/withBpkBreakpoint';
import CenteredSpinner from '@shared/ui/components/CenteredSpinner';
import { FormattedMessage } from '@shared/ui/components/i18n';
import { withI18n } from '@shared/ui/contexts/i18n';

const cls = cssModules(STYLES);

type Props = {
  i18n: I18nService;
  isMobile?: boolean;
  onClose: Function;
};

const PriceCta = ({ i18n, isMobile = false, onClose }: Props) => {
  const price = useLowestPrice().lowestPriceForTraveller;
  const priceIsLoading = !usePollingStatus;
  let priceNode;
  if (priceIsLoading) {
    priceNode = <CenteredSpinner />;
  } else if (price) {
    priceNode = (
      <BpkText
        textStyle={TEXT_STYLES.footnote}
        className={STYLES.PriceCta__price}
        color={TEXT_COLORS.textSecondary}
      >
        <FormattedMessage
          label="roomOptions_label_fromPrice"
          data={{
            price: i18n.formatCurrency(price),
            tag: {
              pair: '/tag',
              // eslint-disable-next-line react/no-unstable-nested-components
              format: (text: string) => (
                <BpkText textStyle={TEXT_STYLES.heading3}>{text}</BpkText>
              ),
            },
          }}
        />
      </BpkText>
    );
  } else {
    priceNode = <span />;
  }
  return (
    <div className={STYLES.PriceCta__priceContainer}>
      {priceNode}

      <BpkButtonV2
        className={cls('PriceCta__bookBtn', 'PriceCta__bookBtnMobile')}
        Primary
        onClick={() => {
          onClose();
          setTimeout(() => {
            scrollToHotelPrices();
          }, 100);
        }}
      >
        {i18n.translate('OTARates_button_viewDeals')}
        {isMobile ? null : (
          <ArrowRightIcon className={STYLES.PriceCta__arrowRightIcon} />
        )}
      </BpkButtonV2>
    </div>
  );
};

export { PriceCta };

export default withBpkBreakpoint(
  withI18n(PriceCta),
  BREAKPOINTS.MOBILE,
  'isMobile',
);
